import React from 'react';
import PropTypes from 'prop-types';

const RegisterConfirmation = ({ closeModal, redirect }) => {
  const continueShopping = (e) => {
    if (!redirect) {
      closeModal();
      e.preventDefault();
    }
  };

  return (
    <div className="tc lh-copy">
      <h2 className="flex justify-center mb3">
        <i className="material-icons green mr1 self-center">check_circle</i>
        Success!
      </h2>
      <div className="mb4 mt1 f4">You now have a<br />Blinds.com account.</div>
      <p className="mb4 mt1 f5">We&rsquo;ll send you an email with a link to confirm your account.</p>
      <a href="/" onClick={continueShopping} className="gcc-btn gcc-btn-primary db mv3 w-100 pa3 bw0 white" data-test-id="continue-shopping-btn">
        Continue Shopping
      </a>
    </div>
  );
};

RegisterConfirmation.defaultProps = {
  redirect: true,
};

RegisterConfirmation.propTypes = {
  closeModal: PropTypes.func.isRequired,
  redirect: PropTypes.bool,
};


export default RegisterConfirmation;
